export default "__VITE_ASSET__yDe8t$mU__"